module.exports = __webpack_public_path__ + "d308073b/img/arrow-left-icon.785c715c.svg";